<template>
  <div class="login-page">
    <div class="login-page__form">
      <TheLogo class="login-page__logo" />
      <div class="login-page__title">
        <h1>Войти в КЭДО ГК «ОСНОВА»</h1>
      </div>
      <LoginForm
        v-if="loginStage == 0"
        ref="loginForm"
        :disabled="loginFormDisabled"
        @submit-phone="loginFormSubmitPhone"
        @submit-code="loginFormSubmitCode"
        @submit-captcha="loginFormSubmitCaptcha"
        @resend="loginFormSubmitPhone"
        :errors="loginFormErrors"
        :phoneHint="phoneHint"
        :need-captcha="!passedCaptcha"
        :passed-captcha="passedCaptcha"
      />
    </div>
  </div>
</template>

<script>
import { inject, ref, onMounted, nextTick, computed } from 'vue'
import LoginForm from '@/components/forms/LoginForm.vue'
import TheLogo from '@/components/TheLogo.vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
export default {
  name: 'LoginPage',
  components: {
    LoginForm,
    TheLogo
  },
  setup() {
    const router = useRouter()
    const store = useStore()
    const api = inject('apiMethods')
    const loginForm = ref()
    const loginFormErrors = ref({})
    const loginFormDisabled = ref(false)
    const loginFormData = ref()
    const loginStage = ref(0)
    const isAuthorized = ref(false)
    const phoneHint = ref('')
    const needCaptcha = ref(false)
    const correctCaptcha = ref(false)

    const passedCaptcha = computed(() => !needCaptcha.value || correctCaptcha.value)
    onMounted(() => {
      api.auth.getCaptcha().then((data) => {
        needCaptcha.value = data.data.captcha
      })
      api.auth.getUser().then((data) => {
        if (window.localStorage.getItem('public_token') !== '') {
          if (data.success && data.data.NQES == 'ACTIVE') {
            api.nqes.getChangeChannelTask().then(data => {
              if (data.data && data.data.state == 'USER_NOTIFIED_ABOUT_CHANNEL_CHANGE_REQUEST') {
                router.push({name: 'NQES', query: {'toggle': '1'}})
                return
              }
              return router.push({name: 'Documents'})
            })
          } else {
            if (data.success && (data.data.NQES == 'USER_NOTIFIED_ABOUT_ISSUE_REQUEST' || data.data.NQES == 'USER_NOTIFIED_ABOUT_CERTIFICATE')) {
              router.push({name: 'NQES'})
            }
          }
        }
      })
    })
    return {
      loginForm,
      loginFormErrors,
      loginFormData,
      loginStage,
      loginFormDisabled,
      isAuthorized,
      phoneHint,
      needCaptcha,
      passedCaptcha,
      loginFormSubmitPhone: (data) => {
        if (!data) {
          loginFormErrors.value = {
            phone: 'Введите номер телефона'
          }
          return
        }
        loginFormData.value = data
        loginFormDisabled.value = true
        const code = api.auth.requestCode(data)
        code.then(data => {
          if (!data.success) {
            if (data.data.message) {
              loginFormErrors.value = {
                phone: data.data.message
              }
            }
            return
          } else {
            needCaptcha.value = !!data.data.captcha
            correctCaptcha.value = false
            loginForm.value.showCodeField()
            loginForm.value.setTimeout(parseInt(data.data.timeout) ?? 60)
            store.dispatch('updateToken', data.data.public_token)
          }
          if (!loginFormErrors.value.phone) {
            phoneHint.value = 'Если номер зарегистрирован, на него отправлен код подтверждения'
          }
        })
        .catch(() => {
          loginFormErrors.value = {
            phone: 'Не удалось отправить код'
          }
        })
        .finally(() => {
          loginFormDisabled.value = false
        })
      },
      loginFormSubmitCode: (data) => {
        if (!data) {
          loginFormErrors.value = {
            code: 'Введите код'
          }
          return
        }
        loginFormDisabled.value = true
        const code = api.auth.login(data, store.getters.getPublicToken)
        code.then((data) => {
          if (!data.success) {
            loginFormErrors.value = {
              code: 'Неверный код'
            }
            return
          } else {
            store.dispatch('updateToken', data.data.session.access_token)
            store.dispatch('getUserProperties')
            const nqes = data.data.NQES
            return api.nqes.getChangeChannelTask().then(data => {
              if (data.data && data.data.state == 'USER_NOTIFIED_ABOUT_CHANNEL_CHANGE_REQUEST') {
                isAuthorized.value = true
                router.push({name: 'NQES', query: {'toggle': '1'}})
                return
              }
              if (nqes == 'ACTIVE') {
                isAuthorized.value = true
                router.push({name: 'Documents'})
                return
              }
              if (nqes == 'ANNULLED') {
                loginFormErrors.value = {
                  phone: 'Нет действующего сертификата',
                  code: ''
                }
                loginForm.value.reset()
                
                return
              }
              if (nqes == 'NONE') {
                loginFormErrors.value = {
                  phone: 'Сертификат не действителен, и пользователь не приглашен',
                  code: ''
                }
                loginForm.value.reset()
                return
              }
              if (nqes == 'NQES_ISSUE_REQUEST_FAILED' || nqes == 'ISSUING_REJECTED') {
                loginFormErrors.value = {
                  phone: 'Заявка на выпуск УНЭП завершилась с ошибкой',
                  code: ''
                }
                loginForm.value.reset()
                return
              }
              
              if (
                nqes == 'USER_NOTIFIED_ABOUT_ISSUE_REQUEST'
                || nqes == 'USER_NOTIFIED_ABOUT_CERTIFICATE'
                || nqes == 'NQES_ISSUE_REQUEST_CREATED'
              ) {
                isAuthorized.value = true
                nextTick(() => {
                  router.push({name: 'NQES'})
                })

                return
              }
              loginFormErrors.value = {
                phone: 'Сертификат не действителен или отсутствует заявление на выпуск',
                code: ''
              }
              loginForm.value.reset()
              return
            })
          }
        })
        .finally(() => {
          if (!isAuthorized.value) {
            loginFormDisabled.value = false
          }
        })
      },
      loginFormSubmitCaptcha: (e) => {
        api.auth.validateCaptcha(e).then((data) => {
          correctCaptcha.value = data.data.passed_captcha
        }).finally(() => {
          loginForm.value.resetCaptcha()
        })
      }
    }
  }
}
</script>

<style lang="scss">
.login-page {
  display: flex;
  padding: 80px 30px 30px 30px;

  &__title {
    margin-bottom: 80px;
  }

  &__form {
    width: 300px;
  }
  &__content {
    width: calc(100% - 300px);
  }
  &__logo {
    margin-bottom: 10px;
  }
}
</style>
